<template>
  <div class="col-sm-12 nopads">
    <div class="search-form px-2 my-2">
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <div class="row">
        <div class="col-sm-6">
          <span class="search-title">
            {{ $t('ins_report.from_date') }}
          </span>
          <date-time-picker
            v-model:date="fromDate"
            class="routa-input"
            format="dd.MM.yyyy HH:mm"
            :enableTimePicker="true"
            :set-time-button-visible="true"
            :placeholder="$t('observations_videos.search_input_format')"
          />
        </div>

        <div class="col-sm-6">
          <span class="search-title">
            {{ $t('ins_report.to_date') }}
          </span>
          <date-time-picker
            v-model:date="toDate"
            class="routa-input"
            format="dd.MM.yyyy HH:mm"
            :enableTimePicker="true"
            :set-time-button-visible="true"
            :placeholder="$t('observations_videos.search_input_format')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <span class="search-title">{{ $t('trip_list.search_with_road_num') }}</span>
            <input
                id="roadInput"
                v-model="roadNumber"
                type="number"
                class="form-control form-control-sm no-margin"
                :placeholder="$t('trip_list.search_with_road_num')"
            />
        </div>
        <div class="col-sm-6">
          <span class="search-title">{{ $t('trip_list.search_with_road_name') }}</span>
            <input
                id="roadNameInput"
                v-model="roadName"
                type="text"
                class="form-control form-control-sm no-margin"
                :placeholder="$t('trip_list.search_with_road_name')"
            />
        </div>
      </div>
      <div class="col-sm-12 button-container">
        <button
          class="btn btn-danger form-button"
          @click="onReset"
        >
          {{ $t('ins_report.clear') }}
        </button>
          <button
              class="btn btn-primary form-button"
              @click="onSubmit"
          >
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from '../mixins/TimeUtils'
import DateTimePicker from "@/components/common/DateTimePicker";

export default {
    name: 'TripSearchWorker',
    components: { DateTimePicker },
    mixins: [restApi, timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            fromDate: '',
            toDate: '',
            roadNumber: '',
            roadName: '',
            loading: false
        }
    },

    mounted: function () {
        if (!this.fromDate) {
            this.fromDate = this.getMonthStart()
        }
    },

    methods: {

        onReset: function () {
            this.roadNumber = ''
            this.roadName = ''
            this.fromDate = ''
            this.toDate = ''
        },

        onSubmit: function () {
            var params = {}
            params.user = this.user.id
            if (this.roadNumber > 0) {
                params.road_num = this.roadNumber
            }
            if (this.roadName.trim()) {
                params.road_name = this.roadName
            }
            if (this.fromDate) {
                params.from = this.fromDate
            }
            if (this.toDate) {
                params.to = this.toDate
            }
            this.$emit('search', params)
        }
    }
}
</script>

<style scoped>
</style>
